export const saveMap = (map) => ({ type: 'SAVE_MAP', payload: map });
